// extracted by mini-css-extract-plugin
export var breadcrumb = "Breadcrumbs-module--breadcrumb--dc0e0";
export var breadcrumbdivider = "Breadcrumbs-module--breadcrumbdivider--abbf6";
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--f2ba3";
export var breadcrumbswrapper = "Breadcrumbs-module--breadcrumbswrapper--0b016";
export var chevron = "Breadcrumbs-module--chevron--f5a45";